export default "__VITE_ASSET__BNu$l05S__"